module.exports = __webpack_public_path__ + "img/md-item04.b01338a.png";